// extracted by mini-css-extract-plugin
export default {"root":"SignHeader_root__ubBHJ","title":"SignHeader_title__eY0e2","back":"SignHeader_back__lHHWp","info":"SignHeader_info__leKPb"};